// Copyright(C)2025 Sky CO., LTD.
/****************************************************************//*
 @file
    SettingResource.ts

 @brief
    設定 メッセージ定義

 @details

    ・本クラスはメッセージ一覧マクロで出力されたシングルトンの
      メッセージ定義クラスです。本クラスは直接編集せず、
      メッセージ一覧マクロから出力してください。

    ●文言定義（Str_～）
        文言を定義したプロパティです。
        【例】
            let hoge = Resource.xxxResource.getInstance().Str_Hoge;

    ●メッセージボックス定義（Msg_～）
        メッセージボックス用のメッセージを定義したプロパティです。
        【例】
            let info = Resource.xxxResource.getInstance().Msg_Piyo;

 @author
    sky

 @attention

 @note
    2026/06/24 16:51:49
 ****************************************************************///
import { ShowMessageBoxParams } from 'lib-vue-v2/composables/useMessageBox';
import { MessageBoxFlags } from 'lib-vue-v2/components';

export namespace Resource {

    /** 関数でメッセージ定義を取得するための紐づけID */
    export const enum MsgID {
        Alt_SendMailOnMailAddressEmptyWarn = 'Alt_SendMailOnMailAddressEmptyWarn',
        Alt_SendMailOnMailAddressEmptyUnauthorizedWarn = 'Alt_SendMailOnMailAddressEmptyUnauthorizedWarn',
        Alt_Assets_EssAppIns_ComfirmAddOverSize = 'Alt_Assets_EssAppIns_ComfirmAddOverSize',
        Alt_Assets_EssAppIns_ComfirmAddSameApp = 'Alt_Assets_EssAppIns_ComfirmAddSameApp',
        Alt_Assets_EssAppIns_ComfirmAddKeywordLength = 'Alt_Assets_EssAppIns_ComfirmAddKeywordLength',
        Swt_Assets_MinFreeSpaceDifferenceInvalid = 'Swt_Assets_MinFreeSpaceDifferenceInvalid',
        UserItem_Assets_InputUserItemInvalid = 'UserItem_Assets_InputUserItemInvalid',
        Alt_Common_IllegalTerminal_AssetsRegistConfirm = 'Alt_Common_IllegalTerminal_AssetsRegistConfirm',
        Alt_Common_IllegalTerminal_AssetsRegistComplete = 'Alt_Common_IllegalTerminal_AssetsRegistComplete',
        Alt_Common_IllegalTerminal_IpAddressExclusion = 'Alt_Common_IllegalTerminal_IpAddressExclusion',
        Alt_Common_IllegalTerminal_IpAddressExclusion_Duplicate = 'Alt_Common_IllegalTerminal_IpAddressExclusion_Duplicate',
        Alt_Common_IllegalTerminal_InternalNetwork_NowUsing = 'Alt_Common_IllegalTerminal_InternalNetwork_NowUsing',
        Ast_Common_M365Link_Confirm_ClearSetting = 'Ast_Common_M365Link_Confirm_ClearSetting',
        Ast_Common_M365Link_Confirm_ReissueCert = 'Ast_Common_M365Link_Confirm_ReissueCert',
        Ast_Common_M365Link_Info_CompleteCert = 'Ast_Common_M365Link_Info_CompleteCert',
        Ast_Common_M365Link_Warn_SelectLimit = 'Ast_Common_M365Link_Warn_SelectLimit',
        Ast_Common_M365Link_Warn_NotAvailable = 'Ast_Common_M365Link_Warn_NotAvailable',
        Ast_Common_M365Link_Warn_RegisterLimit = 'Ast_Common_M365Link_Warn_RegisterLimit',
        Ast_Common_M365Link_Warn_SettingRestrictNewOutlook = 'Ast_Common_M365Link_Warn_SettingRestrictNewOutlook',
        Ast_Common_M365Link_Warn_ProhibitAttachmentMailWithM365MailLicence = 'Ast_Common_M365Link_Warn_ProhibitAttachmentMailWithM365MailLicence',
        Alt_Other_IllegalTerminal_NotUpdatePermission = 'Alt_Other_IllegalTerminal_NotUpdatePermission',
        Alt_Other_IllegalTerminal_NotSelectedSegment = 'Alt_Other_IllegalTerminal_NotSelectedSegment',
        Alt_Other_IllegalTerminal_NeedSegmentConfirm = 'Alt_Other_IllegalTerminal_NeedSegmentConfirm',
        Alt_Other_IllegalTerminal_SendMaileNotUpdatePermission = 'Alt_Other_IllegalTerminal_SendMaileNotUpdatePermission',
        Alt_Other_IllegalTerminal_NetworkDeviceLimitOverError = 'Alt_Other_IllegalTerminal_NetworkDeviceLimitOverError',
        Alt_Other_IllegalTerminal_DetectionAgentLimitOverSelectError = 'Alt_Other_IllegalTerminal_DetectionAgentLimitOverSelectError',
        Alt_Other_IllegalTerminal_DetectionAgentLimitOverError = 'Alt_Other_IllegalTerminal_DetectionAgentLimitOverError',
        Ast_Common_M365Link_Warn_NotIssueCert = 'Ast_Common_M365Link_Warn_NotIssueCert',
        Log_Default_M365Link_Warn_Inport_NotFindAgtID = 'Log_Default_M365Link_Warn_Inport_NotFindAgtID',
        Ast_Common_Protection_ExclusionAgentLimitOverError = 'Ast_Common_Protection_ExclusionAgentLimitOverError',
        Ast_Common_Protection_ExclusionAgentLimitOverSelectError = 'Ast_Common_Protection_ExclusionAgentLimitOverSelectError',
        Alt_Common_IllegalTerminal_WarningTerminalAlreadyRegistered = 'Alt_Common_IllegalTerminal_WarningTerminalAlreadyRegistered',
        Log_Default_M365Link_Info_Inport_UseInfo = 'Log_Default_M365Link_Info_Inport_UseInfo',
        Log_Default_M365Link_Error_FailedGetLinkInfo = 'Log_Default_M365Link_Error_FailedGetLinkInfo',
        Ast_Common_M365Link_Error_FailedReissueCert = 'Ast_Common_M365Link_Error_FailedReissueCert',
        Ast_Common_M365Link_Info_PublishCert = 'Ast_Common_M365Link_Info_PublishCert',
        Log_Default_M365Link_Warn_OldUserInfo = 'Log_Default_M365Link_Warn_OldUserInfo',
        Ast_Common_M365Link_Info_CompleteExportCert = 'Ast_Common_M365Link_Info_CompleteExportCert',
        Ast_Common_M365Link_Error_FailedExportCert = 'Ast_Common_M365Link_Error_FailedExportCert',
        Log_Default_M365Link_Error_FailedGetUserInfo = 'Log_Default_M365Link_Error_FailedGetUserInfo',
        Log_Default_M365Link_Info_UpdateUserInfo = 'Log_Default_M365Link_Info_UpdateUserInfo',
        Log_Default_M365Link_Info_ContinueBackGroundUserInfoUpdate = 'Log_Default_M365Link_Info_ContinueBackGroundUserInfoUpdate',
        Log_Default_M365Link_Warn_FailedCommunicationM365Server = 'Log_Default_M365Link_Warn_FailedCommunicationM365Server',
        Mobile_iOS_Profile_Xml_Viewer_FailedCommunication = 'Mobile_iOS_Profile_Xml_Viewer_FailedCommunication',
        Mobile_iOS_Profile_UI_Setting_FailedCommunication = 'Mobile_iOS_Profile_UI_Setting_FailedCommunication',
        Alt_Other_NetworkBlockingSyslog_AllowedConnect_HostAndPortEmpty = 'Alt_Other_NetworkBlockingSyslog_AllowedConnect_HostAndPortEmpty',
        Alt_Other_NetworkBlockingSyslog_AllowedConnect_Duplicate = 'Alt_Other_NetworkBlockingSyslog_AllowedConnect_Duplicate',
        Alt_Other_NetworkBlockingSyslog_AllowedConnectPath_ControlCode = 'Alt_Other_NetworkBlockingSyslog_AllowedConnectPath_ControlCode',
        Alt_Other_NetworkBlockingSyslog_AllowedConnectPath_Empty = 'Alt_Other_NetworkBlockingSyslog_AllowedConnectPath_Empty',
        Alt_Other_NetworkBlockingSyslog_AllowedConnectPath_Duplicate = 'Alt_Other_NetworkBlockingSyslog_AllowedConnectPath_Duplicate',
        Alt_Other_NetworkBlockingSyslog_AllowedConnectPath_NetworkFolderPath = 'Alt_Other_NetworkBlockingSyslog_AllowedConnectPath_NetworkFolderPath',
        Alt_Other_NetworkBlockingSyslog_AllowedConnectPath_Invalid = 'Alt_Other_NetworkBlockingSyslog_AllowedConnectPath_Invalid',
        Alt_Other_NetworkBlockingSyslog_AllowedConnectPath_MultipleWildCard = 'Alt_Other_NetworkBlockingSyslog_AllowedConnectPath_MultipleWildCard',
        Alt_Other_NetworkBlockingSyslog_AllowedConnectPath_FileNameInWildCard = 'Alt_Other_NetworkBlockingSyslog_AllowedConnectPath_FileNameInWildCard',
        Alt_Other_NetworkBlockingSyslog_AllowedConnectPath_InitialWildCard = 'Alt_Other_NetworkBlockingSyslog_AllowedConnectPath_InitialWildCard',
        Alt_Other_NetworkBlockingSyslog_changeVersionButton = 'Alt_Other_NetworkBlockingSyslog_changeVersionButton',
        Alt_Other_NetworkBlockingSyslog_changeYaraiVer = 'Alt_Other_NetworkBlockingSyslog_changeYaraiVer',
        Android_Application_AddPasswordManager_NoAppWhite = 'Android_Application_AddPasswordManager_NoAppWhite',
        Android_Application_AddPasswordManager_NoAppBlack = 'Android_Application_AddPasswordManager_NoAppBlack',
        Android_Application_DeletePasswordManager = 'Android_Application_DeletePasswordManager',
    }

    /** SettingResource */
    export class SettingResource{

        /** メッセージ文言取得関数 */
        public getMsg(id: MsgID): string {
            switch (id) {
                case MsgID.Alt_Other_IllegalTerminal_NotSelectedSegment: return this.Str_Alt_Other_IllegalTerminal_NotSelectedSegment;
                case MsgID.Alt_Other_NetworkBlockingSyslog_AllowedConnectPath_ControlCode: return this.Str_Alt_Other_NetworkBlockingSyslog_AllowedConnectPath_ControlCode;
                case MsgID.Alt_Other_NetworkBlockingSyslog_AllowedConnectPath_Empty: return this.Str_Alt_Other_NetworkBlockingSyslog_AllowedConnectPath_Empty;
                case MsgID.Alt_Other_NetworkBlockingSyslog_AllowedConnectPath_Duplicate: return this.Str_Alt_Other_NetworkBlockingSyslog_AllowedConnectPath_Duplicate;
                case MsgID.Alt_Other_NetworkBlockingSyslog_AllowedConnectPath_NetworkFolderPath: return this.Str_Alt_Other_NetworkBlockingSyslog_AllowedConnectPath_NetworkFolderPath;
                case MsgID.Alt_Other_NetworkBlockingSyslog_AllowedConnectPath_Invalid: return this.Str_Alt_Other_NetworkBlockingSyslog_AllowedConnectPath_Invalid;
                case MsgID.Alt_Other_NetworkBlockingSyslog_AllowedConnectPath_MultipleWildCard: return this.Str_Alt_Other_NetworkBlockingSyslog_AllowedConnectPath_MultipleWildCard;
                case MsgID.Alt_Other_NetworkBlockingSyslog_AllowedConnectPath_FileNameInWildCard: return this.Str_Alt_Other_NetworkBlockingSyslog_AllowedConnectPath_FileNameInWildCard;
                case MsgID.Alt_Other_NetworkBlockingSyslog_AllowedConnectPath_InitialWildCard: return this.Str_Alt_Other_NetworkBlockingSyslog_AllowedConnectPath_InitialWildCard;
                default: return '';
            }
        }

        /** メッセージ情報取得関数 */
        public getMsgInfo(id: MsgID, replaceMessages?: string[]): ShowMessageBoxParams {
            let showMessageBoxParams = { message: '' }
            switch (id) {
                case MsgID.Alt_SendMailOnMailAddressEmptyWarn:
                    showMessageBoxParams = this.Msg_Alt_SendMailOnMailAddressEmptyWarn;
                    break;
                case MsgID.Alt_SendMailOnMailAddressEmptyUnauthorizedWarn:
                    showMessageBoxParams = this.Msg_Alt_SendMailOnMailAddressEmptyUnauthorizedWarn;
                    break;
                case MsgID.Alt_Assets_EssAppIns_ComfirmAddOverSize:
                    showMessageBoxParams = this.Msg_Alt_Assets_EssAppIns_ComfirmAddOverSize;
                    break;
                case MsgID.Alt_Assets_EssAppIns_ComfirmAddSameApp:
                    showMessageBoxParams = this.Msg_Alt_Assets_EssAppIns_ComfirmAddSameApp;
                    break;
                case MsgID.Alt_Assets_EssAppIns_ComfirmAddKeywordLength:
                    showMessageBoxParams = this.Msg_Alt_Assets_EssAppIns_ComfirmAddKeywordLength;
                    break;
                case MsgID.Swt_Assets_MinFreeSpaceDifferenceInvalid:
                    showMessageBoxParams = this.Msg_Swt_Assets_MinFreeSpaceDifferenceInvalid;
                    break;
                case MsgID.UserItem_Assets_InputUserItemInvalid:
                    showMessageBoxParams = this.Msg_UserItem_Assets_InputUserItemInvalid;
                    break;
                case MsgID.Alt_Common_IllegalTerminal_AssetsRegistConfirm:
                    showMessageBoxParams = this.Msg_Alt_Common_IllegalTerminal_AssetsRegistConfirm;
                    break;
                case MsgID.Alt_Common_IllegalTerminal_AssetsRegistComplete:
                    showMessageBoxParams = this.Msg_Alt_Common_IllegalTerminal_AssetsRegistComplete;
                    break;
                case MsgID.Alt_Common_IllegalTerminal_IpAddressExclusion:
                    showMessageBoxParams = this.Msg_Alt_Common_IllegalTerminal_IpAddressExclusion;
                    break;
                case MsgID.Alt_Common_IllegalTerminal_IpAddressExclusion_Duplicate:
                    showMessageBoxParams = this.Msg_Alt_Common_IllegalTerminal_IpAddressExclusion_Duplicate;
                    break;
                case MsgID.Alt_Common_IllegalTerminal_InternalNetwork_NowUsing:
                    showMessageBoxParams = this.Msg_Alt_Common_IllegalTerminal_InternalNetwork_NowUsing;
                    break;
                case MsgID.Ast_Common_M365Link_Confirm_ClearSetting:
                    showMessageBoxParams = this.Msg_Ast_Common_M365Link_Confirm_ClearSetting;
                    break;
                case MsgID.Ast_Common_M365Link_Confirm_ReissueCert:
                    showMessageBoxParams = this.Msg_Ast_Common_M365Link_Confirm_ReissueCert;
                    break;
                case MsgID.Ast_Common_M365Link_Info_CompleteCert:
                    showMessageBoxParams = this.Msg_Ast_Common_M365Link_Info_CompleteCert;
                    break;
                case MsgID.Ast_Common_M365Link_Warn_SelectLimit:
                    showMessageBoxParams = this.Msg_Ast_Common_M365Link_Warn_SelectLimit;
                    break;
                case MsgID.Ast_Common_M365Link_Warn_NotAvailable:
                    showMessageBoxParams = this.Msg_Ast_Common_M365Link_Warn_NotAvailable;
                    break;
                case MsgID.Ast_Common_M365Link_Warn_RegisterLimit:
                    showMessageBoxParams = this.Msg_Ast_Common_M365Link_Warn_RegisterLimit;
                    break;
                case MsgID.Ast_Common_M365Link_Warn_SettingRestrictNewOutlook:
                    showMessageBoxParams = this.Msg_Ast_Common_M365Link_Warn_SettingRestrictNewOutlook;
                    break;
                case MsgID.Ast_Common_M365Link_Warn_ProhibitAttachmentMailWithM365MailLicence:
                    showMessageBoxParams = this.Msg_Ast_Common_M365Link_Warn_ProhibitAttachmentMailWithM365MailLicence;
                    break;
                case MsgID.Alt_Other_IllegalTerminal_NotUpdatePermission:
                    showMessageBoxParams = this.Msg_Alt_Other_IllegalTerminal_NotUpdatePermission;
                    break;
                case MsgID.Alt_Other_IllegalTerminal_NeedSegmentConfirm:
                    showMessageBoxParams = this.Msg_Alt_Other_IllegalTerminal_NeedSegmentConfirm;
                    break;
                case MsgID.Alt_Other_IllegalTerminal_SendMaileNotUpdatePermission:
                    showMessageBoxParams = this.Msg_Alt_Other_IllegalTerminal_SendMaileNotUpdatePermission;
                    break;
                case MsgID.Alt_Other_IllegalTerminal_NetworkDeviceLimitOverError:
                    showMessageBoxParams = this.Msg_Alt_Other_IllegalTerminal_NetworkDeviceLimitOverError;
                    break;
                case MsgID.Alt_Other_IllegalTerminal_DetectionAgentLimitOverSelectError:
                    showMessageBoxParams = this.Msg_Alt_Other_IllegalTerminal_DetectionAgentLimitOverSelectError;
                    break;
                case MsgID.Alt_Other_IllegalTerminal_DetectionAgentLimitOverError:
                    showMessageBoxParams = this.Msg_Alt_Other_IllegalTerminal_DetectionAgentLimitOverError;
                    break;
                case MsgID.Ast_Common_M365Link_Warn_NotIssueCert:
                    showMessageBoxParams = this.Msg_Ast_Common_M365Link_Warn_NotIssueCert;
                    break;
                case MsgID.Log_Default_M365Link_Warn_Inport_NotFindAgtID:
                    showMessageBoxParams = this.Msg_Log_Default_M365Link_Warn_Inport_NotFindAgtID;
                    break;
                case MsgID.Ast_Common_Protection_ExclusionAgentLimitOverError:
                    showMessageBoxParams = this.Msg_Ast_Common_Protection_ExclusionAgentLimitOverError;
                    break;
                case MsgID.Ast_Common_Protection_ExclusionAgentLimitOverSelectError:
                    showMessageBoxParams = this.Msg_Ast_Common_Protection_ExclusionAgentLimitOverSelectError;
                    break;
                case MsgID.Alt_Common_IllegalTerminal_WarningTerminalAlreadyRegistered:
                    showMessageBoxParams = this.Msg_Alt_Common_IllegalTerminal_WarningTerminalAlreadyRegistered;
                    break;
                case MsgID.Log_Default_M365Link_Info_Inport_UseInfo:
                    showMessageBoxParams = this.Msg_Log_Default_M365Link_Info_Inport_UseInfo;
                    break;
                case MsgID.Log_Default_M365Link_Error_FailedGetLinkInfo:
                    showMessageBoxParams = this.Msg_Log_Default_M365Link_Error_FailedGetLinkInfo;
                    break;
                case MsgID.Ast_Common_M365Link_Error_FailedReissueCert:
                    showMessageBoxParams = this.Msg_Ast_Common_M365Link_Error_FailedReissueCert;
                    break;
                case MsgID.Ast_Common_M365Link_Info_PublishCert:
                    showMessageBoxParams = this.Msg_Ast_Common_M365Link_Info_PublishCert;
                    break;
                case MsgID.Log_Default_M365Link_Warn_OldUserInfo:
                    showMessageBoxParams = this.Msg_Log_Default_M365Link_Warn_OldUserInfo;
                    break;
                case MsgID.Ast_Common_M365Link_Info_CompleteExportCert:
                    showMessageBoxParams = this.Msg_Ast_Common_M365Link_Info_CompleteExportCert;
                    break;
                case MsgID.Ast_Common_M365Link_Error_FailedExportCert:
                    showMessageBoxParams = this.Msg_Ast_Common_M365Link_Error_FailedExportCert;
                    break;
                case MsgID.Log_Default_M365Link_Error_FailedGetUserInfo:
                    showMessageBoxParams = this.Msg_Log_Default_M365Link_Error_FailedGetUserInfo;
                    break;
                case MsgID.Log_Default_M365Link_Info_UpdateUserInfo:
                    showMessageBoxParams = this.Msg_Log_Default_M365Link_Info_UpdateUserInfo;
                    break;
                case MsgID.Log_Default_M365Link_Info_ContinueBackGroundUserInfoUpdate:
                    showMessageBoxParams = this.Msg_Log_Default_M365Link_Info_ContinueBackGroundUserInfoUpdate;
                    break;
                case MsgID.Log_Default_M365Link_Warn_FailedCommunicationM365Server:
                    showMessageBoxParams = this.Msg_Log_Default_M365Link_Warn_FailedCommunicationM365Server;
                    break;
                case MsgID.Mobile_iOS_Profile_Xml_Viewer_FailedCommunication:
                    showMessageBoxParams = this.Msg_Mobile_iOS_Profile_Xml_Viewer_FailedCommunication;
                    break;
                case MsgID.Mobile_iOS_Profile_UI_Setting_FailedCommunication:
                    showMessageBoxParams = this.Msg_Mobile_iOS_Profile_UI_Setting_FailedCommunication;
                    break;
                case MsgID.Alt_Other_NetworkBlockingSyslog_AllowedConnect_HostAndPortEmpty:
                    showMessageBoxParams = this.Msg_Alt_Other_NetworkBlockingSyslog_AllowedConnect_HostAndPortEmpty;
                    break;
                case MsgID.Alt_Other_NetworkBlockingSyslog_AllowedConnect_Duplicate:
                    showMessageBoxParams = this.Msg_Alt_Other_NetworkBlockingSyslog_AllowedConnect_Duplicate;
                    break;
                case MsgID.Alt_Other_NetworkBlockingSyslog_changeVersionButton:
                    showMessageBoxParams = this.Msg_Alt_Other_NetworkBlockingSyslog_changeVersionButton;
                    break;
                case MsgID.Alt_Other_NetworkBlockingSyslog_changeYaraiVer:
                    showMessageBoxParams = this.Msg_Alt_Other_NetworkBlockingSyslog_changeYaraiVer;
                    break;
                case MsgID.Android_Application_AddPasswordManager_NoAppWhite:
                    showMessageBoxParams = this.Msg_Android_Application_AddPasswordManager_NoAppWhite;
                    break;
                case MsgID.Android_Application_AddPasswordManager_NoAppBlack:
                    showMessageBoxParams = this.Msg_Android_Application_AddPasswordManager_NoAppBlack;
                    break;
                case MsgID.Android_Application_DeletePasswordManager:
                    showMessageBoxParams = this.Msg_Android_Application_DeletePasswordManager;
                    break;
                default:  //何もしない
                    break;
            }

            // メッセージにオプションで指定した文字列を結合
            if (replaceMessages) {
                let messages: string[] =[];
                replaceMessages.forEach((value) => {
                    messages.push(value)
                })
                showMessageBoxParams.message = showMessageBoxParams.message.format(...messages);
            }

            return showMessageBoxParams;
        }

        // #region シングルトンインスタンス管理

        private static _instance: SettingResource;
        /** シングルトンインスタンス取得 */
        public static getInstance(): SettingResource {
            if (!this._instance) {
                this._instance = new SettingResource();
            }
            return this._instance;
        }
        // #endregion // シングルトンインスタンス管理

        // #region メッセージ定義

        get Msg_Alt_SendMailOnMailAddressEmptyWarn(): ShowMessageBoxParams {
            const msg: ShowMessageBoxParams = {
                message: 'メール通知の通知先メールアドレスが設定されていません。<br />本設定の適用後に「アラート設定 - 共通設定」で通知先メールアドレスを設定してください。',
                caption: '警告',
                flags:
                    MessageBoxFlags.MB_OK |
                    MessageBoxFlags.MB_ICONWARNING |
                    MessageBoxFlags.MB_DEFBUTTON1,
            }
            return msg;
        }

        get Msg_Alt_SendMailOnMailAddressEmptyUnauthorizedWarn(): ShowMessageBoxParams {
            const msg: ShowMessageBoxParams = {
                message: 'メール通知の通知先メールアドレスが設定されていません。<br />システム管理者にご連絡ください。',
                caption: '警告',
                flags:
                    MessageBoxFlags.MB_OK |
                    MessageBoxFlags.MB_ICONWARNING |
                    MessageBoxFlags.MB_DEFBUTTON1,
            }
            return msg;
        }

        get Msg_Alt_Assets_EssAppIns_ComfirmAddOverSize(): ShowMessageBoxParams {
            const msg: ShowMessageBoxParams = {
                message: 'これ以上登録することはできません。<br />インストール必須アプリケーションキーワードの登録上限は%s件です。',
                caption: '警告',
                flags:
                    MessageBoxFlags.MB_OK |
                    MessageBoxFlags.MB_ICONWARNING |
                    MessageBoxFlags.MB_DEFBUTTON1,
            }
            return msg;
        }

        get Msg_Alt_Assets_EssAppIns_ComfirmAddSameApp(): ShowMessageBoxParams {
            const msg: ShowMessageBoxParams = {
                message: 'すでに同じインストール必須アプリケーションキーワードが登録されています。',
                caption: '警告',
                flags:
                    MessageBoxFlags.MB_OK |
                    MessageBoxFlags.MB_ICONWARNING |
                    MessageBoxFlags.MB_DEFBUTTON1,
            }
            return msg;
        }

        get Msg_Alt_Assets_EssAppIns_ComfirmAddKeywordLength(): ShowMessageBoxParams {
            const msg: ShowMessageBoxParams = {
                message: 'キーワードに指定できる文字数（全角%s（半角%s）文字）を超えるため追加できません。',
                caption: '警告',
                flags:
                    MessageBoxFlags.MB_OK |
                    MessageBoxFlags.MB_ICONWARNING |
                    MessageBoxFlags.MB_DEFBUTTON1,
            }
            return msg;
        }

        get Msg_Swt_Assets_MinFreeSpaceDifferenceInvalid(): ShowMessageBoxParams {
            const msg: ShowMessageBoxParams = {
                message: '「データドライブの空き容量に応じてダウンロードを中止する」の最低空き容量は、「ダウンロードが中止／失敗した場合、ダウンロード済みデータを保存する」のデータドライブの最低空き容量よりも5GB以上小さい値を設定してください。',
                caption: '警告',
                flags:
                    MessageBoxFlags.MB_OK |
                    MessageBoxFlags.MB_ICONWARNING |
                    MessageBoxFlags.MB_DEFBUTTON1,
            }
            return msg;
        }

        get Msg_UserItem_Assets_InputUserItemInvalid(): ShowMessageBoxParams {
            const msg: ShowMessageBoxParams = {
                message: '設定した内容に不正な項目が存在するため、適用できません。<br />設定内容を確認してください。',
                caption: '警告',
                flags:
                    MessageBoxFlags.MB_OK |
                    MessageBoxFlags.MB_ICONWARNING |
                    MessageBoxFlags.MB_DEFBUTTON1,
            }
            return msg;
        }

        get Msg_Alt_Common_IllegalTerminal_AssetsRegistConfirm(): ShowMessageBoxParams {
            const msg: ShowMessageBoxParams = {
                message: '選択している端末をハードウェア一覧に登録します。<br />よろしいですか？',
                caption: '確認',
                flags:
                    MessageBoxFlags.MB_UNIQUE |
                    MessageBoxFlags.MB_ICONQUESTION |
                    MessageBoxFlags.MB_DEFBUTTON2,
                uniqueButtonCaptions: [
                    '登録',
                    'キャンセル',
                ]
            }
            return msg;
        }

        get Msg_Alt_Common_IllegalTerminal_AssetsRegistComplete(): ShowMessageBoxParams {
            const msg: ShowMessageBoxParams = {
                message: '部署「所属未定」への登録が完了しました。',
                caption: '情報',
                flags:
                    MessageBoxFlags.MB_OK |
                    MessageBoxFlags.MB_ICONINFORMATION |
                    MessageBoxFlags.MB_DEFBUTTON1,
            }
            return msg;
        }

        get Msg_Alt_Common_IllegalTerminal_IpAddressExclusion(): ShowMessageBoxParams {
            const msg: ShowMessageBoxParams = {
                message: '許可／不許可ハードウェア一覧で、自動登録除外条件に該当する端末が見つかりました。（対象端末：%s台）<br /><br />不許可端末検知の対象から除外する場合は、許可／不許可ハードウェア一覧から削除してください。<br /><br />※自動登録除外条件に該当した端末は、「IPアドレスによる検知除外」列で確認できます。<br />※端末のIPアドレスは、許可／不許可ハードウェア一覧に登録された時点の情報です。最新のIPアドレスとは異なる可能性があります。',
                caption: '情報',
                flags:
                    MessageBoxFlags.MB_OK |
                    MessageBoxFlags.MB_ICONINFORMATION |
                    MessageBoxFlags.MB_DEFBUTTON1,
            }
            return msg;
        }

        get Msg_Alt_Common_IllegalTerminal_IpAddressExclusion_Duplicate(): ShowMessageBoxParams {
            const msg: ShowMessageBoxParams = {
                message: 'すでに登録されているIPアドレスの範囲、IPアドレスが含まれているため追加できません。<br /><br />[登録済みIPアドレス設定]<br />%s',
                caption: '警告',
                flags:
                    MessageBoxFlags.MB_OK |
                    MessageBoxFlags.MB_ICONWARNING |
                    MessageBoxFlags.MB_DEFBUTTON1,
            }
            return msg;
        }

        get Msg_Alt_Common_IllegalTerminal_InternalNetwork_NowUsing(): ShowMessageBoxParams {
            const msg: ShowMessageBoxParams = {
                message: 'アラート項目「不許可端末検知」で設定中のセグメントは削除できません。',
                caption: '警告',
                flags:
                    MessageBoxFlags.MB_OK |
                    MessageBoxFlags.MB_ICONWARNING |
                    MessageBoxFlags.MB_DEFBUTTON1,
            }
            return msg;
        }

        get Msg_Ast_Common_M365Link_Confirm_ClearSetting(): ShowMessageBoxParams {
            const msg: ShowMessageBoxParams = {
                message: '現在の設定内容と、発行済みの証明書をクリアします。<br />設定をクリアすると、「Microsoft 365監査ログ収集」機能は利用できなくなります。<br /><br />クリアしてよろしいですか？',
                caption: '確認',
                flags:
                    MessageBoxFlags.MB_YESNO |
                    MessageBoxFlags.MB_ICONQUESTION |
                    MessageBoxFlags.MB_DEFBUTTON2,
            }
            return msg;
        }

        get Msg_Ast_Common_M365Link_Confirm_ReissueCert(): ShowMessageBoxParams {
            const msg: ShowMessageBoxParams = {
                message: '証明書を再発行します。<br />発行済みの証明書は使用できなくなるため、再発行した証明書を「Azure Portal」のSKYSEA Client View（特権）のアプリケーション画面でアップロードする必要があります。<br /><br />再発行してよろしいですか？<br /><br />※お使いのWebブラウザによっては、発行した証明書のダウンロード時に、警告が表示されることがあります。<br />表示されたメッセージで「保存」や「継続」、「ダウンロードを許可」などを選択して、ダウンロードしてください。',
                caption: '確認',
                flags:
                    MessageBoxFlags.MB_YESNO |
                    MessageBoxFlags.MB_ICONQUESTION |
                    MessageBoxFlags.MB_DEFBUTTON2,
            }
            return msg;
        }

        get Msg_Ast_Common_M365Link_Info_CompleteCert(): ShowMessageBoxParams {
            const msg: ShowMessageBoxParams = {
                message: '証明書の発行が完了しました。<br />発行した証明書を「Azure Portal」のSKYSEA Client View（特権）のアプリケーション画面でアップロードしてください。',
                caption: '情報',
                flags:
                    MessageBoxFlags.MB_OK |
                    MessageBoxFlags.MB_ICONINFORMATION |
                    MessageBoxFlags.MB_DEFBUTTON1,
            }
            return msg;
        }

        get Msg_Ast_Common_M365Link_Warn_SelectLimit(): ShowMessageBoxParams {
            const msg: ShowMessageBoxParams = {
                message: '選択したユーザーをすべて登録すると、紐づけ上限（50件）を超えるため紐づけできません。',
                caption: '警告',
                flags:
                    MessageBoxFlags.MB_OK |
                    MessageBoxFlags.MB_ICONWARNING |
                    MessageBoxFlags.MB_DEFBUTTON1,
            }
            return msg;
        }

        get Msg_Ast_Common_M365Link_Warn_NotAvailable(): ShowMessageBoxParams {
            const msg: ShowMessageBoxParams = {
                message: 'Microsoft 365監査ログ収集を有効にできません。<br />有効にするには、Microsoft Entra ID認証設定を完了する必要があります。<br />「設定 - 資産設定 - 共通設定 - Microsoft Entra ID認証設定」から設定を行ってください。',
                caption: '警告',
                flags:
                    MessageBoxFlags.MB_OK |
                    MessageBoxFlags.MB_ICONWARNING |
                    MessageBoxFlags.MB_DEFBUTTON1,
            }
            return msg;
        }

        get Msg_Ast_Common_M365Link_Warn_RegisterLimit(): ShowMessageBoxParams {
            const msg: ShowMessageBoxParams = {
                message: 'これ以上ユーザーを紐づけられません。<br />紐づけできるユーザーの上限は50件です。',
                caption: '警告',
                flags:
                    MessageBoxFlags.MB_OK |
                    MessageBoxFlags.MB_ICONWARNING |
                    MessageBoxFlags.MB_DEFBUTTON1,
            }
            return msg;
        }

        get Msg_Ast_Common_M365Link_Warn_SettingRestrictNewOutlook(): ShowMessageBoxParams {
            const msg: ShowMessageBoxParams = {
                message: '「Microsoft 365監査ログ用設定」の「メール送信（「新しいOutlook」を含む）」が有効の場合、本設定を有効にしても「新しいOutlook」の利用は制限されません。',
                caption: '警告',
                flags:
                    MessageBoxFlags.MB_OK |
                    MessageBoxFlags.MB_ICONWARNING |
                    MessageBoxFlags.MB_DEFBUTTON1,
            }
            return msg;
        }

        get Msg_Ast_Common_M365Link_Warn_ProhibitAttachmentMailWithM365MailLicence(): ShowMessageBoxParams {
            const msg: ShowMessageBoxParams = {
                message: '「禁止」を有効にした場合、添付されたファイルを自動的に削除して、メールの送信を行います。<br /><br />※Microsoft Entra IDユーザーのメールアドレスによるメール送信は、禁止を有効にしても、添付ファイルの削除は行われません。',
                caption: '警告',
                flags:
                    MessageBoxFlags.MB_OK |
                    MessageBoxFlags.MB_ICONWARNING |
                    MessageBoxFlags.MB_DEFBUTTON1,
            }
            return msg;
        }

        get Msg_Alt_Other_IllegalTerminal_NotUpdatePermission(): ShowMessageBoxParams {
            const msg: ShowMessageBoxParams = {
                message: 'アラート項目「端末指定（全部署共通設定）」は「ネットワーク全体」部署を選択している場合のみ設定を変更できます。',
                caption: '警告',
                flags:
                    MessageBoxFlags.MB_OK |
                    MessageBoxFlags.MB_ICONWARNING |
                    MessageBoxFlags.MB_DEFBUTTON1,
            }
            return msg;
        }

        get Str_Alt_Other_IllegalTerminal_NotSelectedSegment(): string {
            return 'セグメントを選択してください。';
        }

        get Msg_Alt_Other_IllegalTerminal_NeedSegmentConfirm(): ShowMessageBoxParams {
            const msg: ShowMessageBoxParams = {
                message: '「検知範囲を限定する」設定が無効のため、検知役端末を持ち出して組織外ネットワークなどに接続した場合でも検知機能が動作します。<br /><br />よろしいですか？',
                caption: '確認',
                flags:
                    MessageBoxFlags.MB_YESNO |
                    MessageBoxFlags.MB_ICONQUESTION |
                    MessageBoxFlags.MB_DEFBUTTON1,
            }
            return msg;
        }

        get Msg_Alt_Other_IllegalTerminal_SendMaileNotUpdatePermission(): ShowMessageBoxParams {
            const msg: ShowMessageBoxParams = {
                message: 'アラート項目「端末指定（全部署共通設定）」のメール通知設定は、「ネットワーク全体」部署を選択している場合のみ設定を変更できます。',
                caption: '警告',
                flags:
                    MessageBoxFlags.MB_OK |
                    MessageBoxFlags.MB_ICONWARNING |
                    MessageBoxFlags.MB_DEFBUTTON1,
            }
            return msg;
        }

        get Msg_Alt_Other_IllegalTerminal_NetworkDeviceLimitOverError(): ShowMessageBoxParams {
            const msg: ShowMessageBoxParams = {
                message: 'これ以上資産情報に登録することはできません。<br />資産情報に登録できるネットワーク機器の登録上限は%s台です。',
                caption: '警告',
                flags:
                    MessageBoxFlags.MB_OK |
                    MessageBoxFlags.MB_ICONWARNING |
                    MessageBoxFlags.MB_DEFBUTTON1,
            }
            return msg;
        }

        get Msg_Alt_Other_IllegalTerminal_DetectionAgentLimitOverSelectError(): ShowMessageBoxParams {
            const msg: ShowMessageBoxParams = {
                message: 'これ以上選択できません。<br />検知役端末の登録上限は500台です。',
                caption: '警告',
                flags:
                    MessageBoxFlags.MB_OK |
                    MessageBoxFlags.MB_ICONWARNING |
                    MessageBoxFlags.MB_DEFBUTTON1,
            }
            return msg;
        }

        get Msg_Alt_Other_IllegalTerminal_DetectionAgentLimitOverError(): ShowMessageBoxParams {
            const msg: ShowMessageBoxParams = {
                message: '登録上限（500台）を超えるため、選択できません。',
                caption: '警告',
                flags:
                    MessageBoxFlags.MB_OK |
                    MessageBoxFlags.MB_ICONWARNING |
                    MessageBoxFlags.MB_DEFBUTTON1,
            }
            return msg;
        }

        get Msg_Ast_Common_M365Link_Warn_NotIssueCert(): ShowMessageBoxParams {
            const msg: ShowMessageBoxParams = {
                message: '証明書を発行してください。',
                caption: '警告',
                flags:
                    MessageBoxFlags.MB_OK |
                    MessageBoxFlags.MB_ICONWARNING |
                    MessageBoxFlags.MB_DEFBUTTON1,
            }
            return msg;
        }

        get Msg_Log_Default_M365Link_Warn_Inport_NotFindAgtID(): ShowMessageBoxParams {
            const msg: ShowMessageBoxParams = {
                message: '以下の端末機No.が見つからないためインポートできません。<br /><br />%s',
                caption: '警告',
                flags:
                    MessageBoxFlags.MB_OK |
                    MessageBoxFlags.MB_ICONWARNING |
                    MessageBoxFlags.MB_DEFBUTTON1,
            }
            return msg;
        }

        get Msg_Ast_Common_Protection_ExclusionAgentLimitOverError(): ShowMessageBoxParams {
            const msg: ShowMessageBoxParams = {
                message: 'これ以上登録することはできません。<br />不正停止監視の除外端末の登録上限は1000です。',
                caption: '警告',
                flags:
                    MessageBoxFlags.MB_OK |
                    MessageBoxFlags.MB_ICONWARNING |
                    MessageBoxFlags.MB_DEFBUTTON1,
            }
            return msg;
        }

        get Msg_Ast_Common_Protection_ExclusionAgentLimitOverSelectError(): ShowMessageBoxParams {
            const msg: ShowMessageBoxParams = {
                message: '選択した端末をすべて登録すると、登録上限（1000件）を超えてしまうため登録できません。',
                caption: '警告',
                flags:
                    MessageBoxFlags.MB_OK |
                    MessageBoxFlags.MB_ICONWARNING |
                    MessageBoxFlags.MB_DEFBUTTON1,
            }
            return msg;
        }

        get Msg_Alt_Common_IllegalTerminal_WarningTerminalAlreadyRegistered(): ShowMessageBoxParams {
            const msg: ShowMessageBoxParams = {
                message: '入力された端末は許可端末として資産情報に登録済みです。<br />資産情報に登録したまま、本画面で許可／不許可の切替を行う場合は"許可（固定）"または"不許可（固定）"を選択してください。',
                caption: '警告',
                flags:
                    MessageBoxFlags.MB_OK |
                    MessageBoxFlags.MB_ICONWARNING |
                    MessageBoxFlags.MB_DEFBUTTON1,
            }
            return msg;
        }

        get Msg_Log_Default_M365Link_Info_Inport_UseInfo(): ShowMessageBoxParams {
            const msg: ShowMessageBoxParams = {
                message: 'インポートを行います。<br />ユーザーと端末の紐づけには以下の情報を使用します。<br /><br />・端末機No.<br />・紐づけ済みメールアドレス',
                caption: '情報',
                flags:
                    MessageBoxFlags.MB_OK |
                    MessageBoxFlags.MB_ICONINFORMATION |
                    MessageBoxFlags.MB_DEFBUTTON1,
            }
            return msg;
        }

        get Msg_Log_Default_M365Link_Error_FailedGetLinkInfo(): ShowMessageBoxParams {
            const msg: ShowMessageBoxParams = {
                message: '紐づけ情報の取得に失敗しました。',
                caption: 'エラー',
                flags:
                    MessageBoxFlags.MB_OK |
                    MessageBoxFlags.MB_ICONERROR |
                    MessageBoxFlags.MB_DEFBUTTON1,
            }
            return msg;
        }

        get Msg_Ast_Common_M365Link_Error_FailedReissueCert(): ShowMessageBoxParams {
            const msg: ShowMessageBoxParams = {
                message: '証明書の発行に失敗しました。',
                caption: 'エラー',
                flags:
                    MessageBoxFlags.MB_OK |
                    MessageBoxFlags.MB_ICONERROR |
                    MessageBoxFlags.MB_DEFBUTTON1,
            }
            return msg;
        }

        get Msg_Ast_Common_M365Link_Info_PublishCert(): ShowMessageBoxParams {
            const msg: ShowMessageBoxParams = {
                message: '証明書を発行します。<br /><br />※お使いのWebブラウザによっては、発行した証明書のダウンロード時に、警告が表示されることがあります。<br />表示されたメッセージで「保存」や「継続」、「ダウンロードを許可」などを選択して、ダウンロードしてください。',
                caption: '情報',
                flags:
                    MessageBoxFlags.MB_OK |
                    MessageBoxFlags.MB_ICONINFORMATION |
                    MessageBoxFlags.MB_DEFBUTTON1,
            }
            return msg;
        }

        get Msg_Log_Default_M365Link_Warn_OldUserInfo(): ShowMessageBoxParams {
            const msg: ShowMessageBoxParams = {
                message: '情報の取得に失敗しました。<br />Microsoft Entra IDユーザーの情報が最新ではない可能性があります。',
                caption: '警告',
                flags:
                    MessageBoxFlags.MB_OK |
                    MessageBoxFlags.MB_ICONWARNING |
                    MessageBoxFlags.MB_DEFBUTTON1,
            }
            return msg;
        }

        get Msg_Ast_Common_M365Link_Info_CompleteExportCert(): ShowMessageBoxParams {
            const msg: ShowMessageBoxParams = {
                message: '証明書の出力が完了しました。<br />出力した証明書を「Azure Portal」のSKYSEA Client View（特権）のアプリケーション画面でアップロードしてください。',
                caption: '情報',
                flags:
                    MessageBoxFlags.MB_OK |
                    MessageBoxFlags.MB_ICONINFORMATION |
                    MessageBoxFlags.MB_DEFBUTTON1,
            }
            return msg;
        }

        get Msg_Ast_Common_M365Link_Error_FailedExportCert(): ShowMessageBoxParams {
            const msg: ShowMessageBoxParams = {
                message: '証明書の出力に失敗しました。',
                caption: 'エラー',
                flags:
                    MessageBoxFlags.MB_OK |
                    MessageBoxFlags.MB_ICONERROR |
                    MessageBoxFlags.MB_DEFBUTTON1,
            }
            return msg;
        }

        get Msg_Log_Default_M365Link_Error_FailedGetUserInfo(): ShowMessageBoxParams {
            const msg: ShowMessageBoxParams = {
                message: 'Microsoft Entra IDユーザーの情報の取得に失敗しました。',
                caption: 'エラー',
                flags:
                    MessageBoxFlags.MB_OK |
                    MessageBoxFlags.MB_ICONERROR |
                    MessageBoxFlags.MB_DEFBUTTON1,
            }
            return msg;
        }

        get Msg_Log_Default_M365Link_Info_UpdateUserInfo(): ShowMessageBoxParams {
            const msg: ShowMessageBoxParams = {
                message: 'Microsoft Entra IDユーザーの情報の更新が完了しました。',
                caption: '情報',
                flags:
                    MessageBoxFlags.MB_OK |
                    MessageBoxFlags.MB_ICONINFORMATION |
                    MessageBoxFlags.MB_DEFBUTTON1,
            }
            return msg;
        }

        get Msg_Log_Default_M365Link_Info_ContinueBackGroundUserInfoUpdate(): ShowMessageBoxParams {
            const msg: ShowMessageBoxParams = {
                message: 'Microsoft Entra IDユーザーの情報の更新処理はバックグラウンドで継続されます。<br />しばらくしてから、本画面を開き直してください。',
                caption: '情報',
                flags:
                    MessageBoxFlags.MB_OK |
                    MessageBoxFlags.MB_ICONINFORMATION |
                    MessageBoxFlags.MB_DEFBUTTON1,
            }
            return msg;
        }

        get Msg_Log_Default_M365Link_Warn_FailedCommunicationM365Server(): ShowMessageBoxParams {
            const msg: ShowMessageBoxParams = {
                message: 'Microsoft 365接続サーバーとの通信に失敗しました。',
                caption: '警告',
                flags:
                    MessageBoxFlags.MB_OK |
                    MessageBoxFlags.MB_ICONWARNING |
                    MessageBoxFlags.MB_DEFBUTTON1,
            }
            return msg;
        }

        get Msg_Mobile_iOS_Profile_Xml_Viewer_FailedCommunication(): ShowMessageBoxParams {
            const msg: ShowMessageBoxParams = {
                message: '設定内容の読み込みに失敗しました。',
                caption: 'エラー',
                flags:
                    MessageBoxFlags.MB_OK |
                    MessageBoxFlags.MB_ICONERROR |
                    MessageBoxFlags.MB_DEFBUTTON1,
            }
            return msg;
        }

        get Msg_Mobile_iOS_Profile_UI_Setting_FailedCommunication(): ShowMessageBoxParams {
            const msg: ShowMessageBoxParams = {
                message: '設定の登録に失敗しました。',
                caption: 'エラー',
                flags:
                    MessageBoxFlags.MB_OK |
                    MessageBoxFlags.MB_ICONERROR |
                    MessageBoxFlags.MB_DEFBUTTON1,
            }
            return msg;
        }

        get Msg_Alt_Other_NetworkBlockingSyslog_AllowedConnect_HostAndPortEmpty(): ShowMessageBoxParams {
            const msg: ShowMessageBoxParams = {
                message: 'コンピューター名／IPアドレスまたはポート番号を入力してください。',
                caption: '警告',
                flags:
                    MessageBoxFlags.MB_OK |
                    MessageBoxFlags.MB_ICONWARNING |
                    MessageBoxFlags.MB_DEFBUTTON1,
            }
            return msg;
        }

        get Msg_Alt_Other_NetworkBlockingSyslog_AllowedConnect_Duplicate(): ShowMessageBoxParams {
            const msg: ShowMessageBoxParams = {
                message: 'すでに同じ組み合わせの条件が登録されています。<br />・通信の方向<br />・コンピューター名／IPアドレス<br />・ポート番号<br />・プロトコル',
                caption: '警告',
                flags:
                    MessageBoxFlags.MB_OK |
                    MessageBoxFlags.MB_ICONWARNING |
                    MessageBoxFlags.MB_DEFBUTTON1,
            }
            return msg;
        }

        get Str_Alt_Other_NetworkBlockingSyslog_AllowedConnectPath_ControlCode(): string {
            return '/ ?  " < > |および制御コードは使用できません。';
        }

        get Str_Alt_Other_NetworkBlockingSyslog_AllowedConnectPath_Empty(): string {
            return '入力必須項目です。';
        }

        get Str_Alt_Other_NetworkBlockingSyslog_AllowedConnectPath_Duplicate(): string {
            return 'すでに同じ実行ファイルパスが登録されています。';
        }

        get Str_Alt_Other_NetworkBlockingSyslog_AllowedConnectPath_NetworkFolderPath(): string {
            return 'ネットワークフォルダ上のファイルは指定できません。';
        }

        get Str_Alt_Other_NetworkBlockingSyslog_AllowedConnectPath_Invalid(): string {
            return '絶対パスで指定してください。';
        }

        get Str_Alt_Other_NetworkBlockingSyslog_AllowedConnectPath_MultipleWildCard(): string {
            return 'ワイルドカード（*）が2箇所以上使用されています。';
        }

        get Str_Alt_Other_NetworkBlockingSyslog_AllowedConnectPath_FileNameInWildCard(): string {
            return 'ファイル名にワイルドカード（*）は使用できません。';
        }

        get Str_Alt_Other_NetworkBlockingSyslog_AllowedConnectPath_InitialWildCard(): string {
            return 'ワイルドカード（*）は先頭に使用できません。';
        }

        get Msg_Alt_Other_NetworkBlockingSyslog_changeVersionButton(): ShowMessageBoxParams {
            const msg: ShowMessageBoxParams = {
                message: '「対象とするFFRI yaraiのバージョン変更」の設定は、「ネットワーク全体」部署を選択している場合のみ設定を変更できます。',
                caption: '警告',
                flags:
                    MessageBoxFlags.MB_OK |
                    MessageBoxFlags.MB_ICONWARNING |
                    MessageBoxFlags.MB_DEFBUTTON1,
            }
            return msg;
        }

        get Msg_Alt_Other_NetworkBlockingSyslog_changeYaraiVer(): ShowMessageBoxParams {
            const msg: ShowMessageBoxParams = {
                message: '変更すると、すべての部署の「アラート対象syslog」から<br />「%s」の設定が削除されます。<br />変更してもよろしいですか？',
                caption: '確認',
                flags:
                    MessageBoxFlags.MB_YESNO |
                    MessageBoxFlags.MB_ICONQUESTION |
                    MessageBoxFlags.MB_DEFBUTTON2,
            }
            return msg;
        }

        get Msg_Android_Application_AddPasswordManager_NoAppWhite(): ShowMessageBoxParams {
            const msg: ShowMessageBoxParams = {
                message: '「利用を許可するアプリケーション（ホワイトリスト）」にアプリケーションが登録されていないため、パスワードマネージャー設定は行えません。<br />「利用を許可するアプリケーション（ホワイトリスト）」にアプリケーションを登録してください。',
                caption: '警告',
                flags:
                    MessageBoxFlags.MB_OK |
                    MessageBoxFlags.MB_ICONWARNING |
                    MessageBoxFlags.MB_DEFBUTTON1,
            }
            return msg;
        }

        get Msg_Android_Application_AddPasswordManager_NoAppBlack(): ShowMessageBoxParams {
            const msg: ShowMessageBoxParams = {
                message: '「利用設定するアプリケーション」にアプリケーションが登録されていないため、パスワードマネージャー設定を行えません。<br />「利用設定するアプリケーション」にアプリケーションを登録してください。',
                caption: '警告',
                flags:
                    MessageBoxFlags.MB_OK |
                    MessageBoxFlags.MB_ICONWARNING |
                    MessageBoxFlags.MB_DEFBUTTON1,
            }
            return msg;
        }

        get Msg_Android_Application_DeletePasswordManager(): ShowMessageBoxParams {
            const msg: ShowMessageBoxParams = {
                message: '以下のアプリケーションが、パスワードマネージャーに設定されています。<br />削除してよろしいですか？<br /><br />%s',
                caption: '確認',
                flags:
                    MessageBoxFlags.MB_YESNO |
                    MessageBoxFlags.MB_ICONQUESTION |
                    MessageBoxFlags.MB_DEFBUTTON2,
            }
            return msg;
        }

        // #endregion // メッセージ定義

    }
}
// Copyright(C)2025 Sky CO., LTD.
